<style lang="scss" scoped>
.home {
  padding: 5px;
  margin-top: -10px;
  width: 100;
  height: 100;
  // border: 3px solid #000;
  margin: 0 auto;
  box-shadow: 0px 0px 0px 12px #dddcdc;

  ::v-deep .el-card__body {
    padding-bottom: 10px;
  }
}


.info_home {
  padding: 0;
  margin-top: -10px;
  width: 70%;
  height: 29%;
  // border: 3px solid #000;
  margin: 0 auto;

  ::v-deep .el-card__body {
    padding-bottom: 10px;
  }
}

.gs_home {
  padding: 0;
  margin-top: -10px;
  width: 70%;
  height: 34%;
  // border: 3px solid #000;
  margin: 0 auto;

  ::v-deep .el-card__body {
    padding-bottom: 10px;
  }
}

.gr_home {
  padding: 0;
  margin-top: -10px;
  width: 70%;
  height: 34%;
  margin: 0 auto;

  ::v-deep .el-card__body {
    padding-bottom: 10px;
  }
}

.ys_icon {
  font-size: 30px;
  color: #dfdfdf;
}
</style>

<template>
  <div class="home" v-loading="loading">
    <div class="info_home">
      <div style="margin:10px;">
        <el-row>
          <el-col :span="4">
            <el-image
              style="border-radius:0%;margin-left:-50%;margin-top:20%;width:150px;height:150px;box-shadow: 0px 0px 0px 10px #dfdfdf;"
              :src="url"></el-image>

            <!-- <div v-if="this.is_bind == 0"
              style=" border-radius:20%; margin-top:20%; width:80%; height:200px; box-shadow: 0px 0px 0px 10px #dfdfdf; text-align: center; line-height: 200px;  background-color:rgb(172, 172, 172);">
              <el-button type="text" style="font-size: 22px" @click="bind_visible = true">点击绑定应用</el-button>
            </div> -->

          </el-col>
          <el-col :span="18">
            <div style="margin-top: 4%; font-size: 20px; line-height: 200%;">
              <div>
                绑定房间 ：
                <span>{{ userInfo.romm_name }}</span>
              </div>
              <div>
                房间ID ：
                <span>{{ userInfo.romm_code }}</span>
              </div>
              <div>
                邀请链接 ：
                <span>{{ userInfo.url }}</span>
                <el-button type="primary" v-clipboard:copy="userInfo.url" v-clipboard:success="copy">复制</el-button>
              </div>
              <div>
                邀请码（显示APP外显ID）：
                <span>{{ userInfo.bind_DisplayId }} </span>
                <el-button type="primary" v-clipboard:copy="userInfo.bind_DisplayId"
                  v-clipboard:success="copy">复制</el-button>
              </div>
              <div>
                短码（未使用）：
                <span>{{ userInfo.search_no }} </span>
                <el-button type="primary" v-clipboard:copy="userInfo.search_no" v-clipboard:success="copy">复制</el-button>
              </div>
            </div>
          </el-col>
          <el-col :span="2">
            <el-button icon="el-icon-refresh" style="float: right;margin-top: 40%; "
              @click="getInfoSearch()">刷新一下</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="gs_home" v-if="this.user_role_name != ''">
      <div class="mg_10">
        <span style="font-size: 30px;">{{ user_role_name }}</span>
      </div>
      <el-row>
        <el-col :span="8">
          <div class="mg_10">
            <el-card class="box-card" shadow="always" style="background-color: white;">
              <div slot="header" class="clearfix">
                <span style="font-size: 26px;">用户充值</span>
              </div>
              <el-row style="font-size: 16px;">
                <el-col :span="12">
                  <div>
                    今日充值（¥）
                    <p>{{ rechargeDetail.toDay_recharge}}</p>
                  </div>
                  <div>
                    昨天充值（¥）
                    <p>{{ rechargeDetail.yesDay_recharge}}</p>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div>
                    本月充值（¥）
                    <p>{{ rechargeDetail.toMonth_recharge}}</p>
                  </div>
                  <div>
                    上月充值（¥）
                    <p>{{ rechargeDetail.yesMonth_recharge}}</p>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="mg_10">
            <el-card class="box-card" shadow="always">
              <div slot="header" class="clearfix">
                <span style="font-size: 26px;">公会代充</span>
              </div>
              <el-row style="font-size: 16px;">
                <el-col :span="12">
                  <div>
                    今日代充（币）
                    <p>{{ sociatyDetail.toDay_sociaty }}</p>
                  </div>
                  <div>
                    昨日代充（币）
                    <p>{{ sociatyDetail.yesDay_sociaty }}</p>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div>
                    本月代充（币）
                    <p>{{ sociatyDetail.toMonth_sociaty }}</p>
                  </div>
                  <div>
                    上月代充（币）
                    <p>{{ sociatyDetail.yesMonth_sociaty }}</p>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="mg_10">
            <el-card class="box-card" shadow="always">
              <div slot="header" class="clearfix">
                <span style="font-size: 26px;">用户邀请</span>
              </div>
              <el-row style="font-size: 16px;">
                <el-col :span="12">
                  <div>
                    今日有效注册数
                    <p>{{ inviteDetail.toDay_invite }}</p>
                  </div>
                  <div>
                    昨日有效注册数
                    <p>{{ inviteDetail.yesDay_invite }}</p>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div>
                    本月有效注册数
                    <p>{{ inviteDetail.toMonth_invite }}</p>
                  </div>
                  <div>
                    上月有效注册数
                    <p>{{ inviteDetail.yesMonth_invite }}</p>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="gr_home">
      <div class="mg_10">
        <span style="font-size: 30px;">个人统计</span>
      </div>
      <el-row>
        <el-col :span="8">
          <div class="mg_10">
            <el-card class="box-card" shadow="always" style="background-color: white;">
              <div slot="header" class="clearfix">
                <span style="font-size: 26px;">用户充值</span>
              </div>
              <el-row style="font-size: 16px;">
                <el-col :span="12">
                  <div>
                    今日充值（¥）
                    <p>{{ recharge.toDay_recharge}}</p>
                  </div>
                  <div>
                    昨天充值（¥）
                    <p>{{ recharge.yesDay_recharge}}</p>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div>
                    本月充值（¥）
                    <p>{{ recharge.toMonth_recharge}}</p>
                  </div>
                  <div>
                    上月充值（¥）
                    <p>{{ recharge.yesMonth_recharge}}</p>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="mg_10">
            <el-card class="box-card" shadow="always">
              <div slot="header" class="clearfix">
                <span style="font-size: 26px;">公会代充</span>
              </div>
              <el-row style="font-size: 16px;">
                <el-col :span="12">
                  <div>
                    今日代充（币）
                    <p>{{ sociaty.toDay_sociaty }}</p>
                  </div>
                  <div>
                    昨日代充（币）
                    <p>{{ sociaty.yesDay_sociaty }}</p>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div>
                    本月代充（币）
                    <p>{{ sociaty.toMonth_sociaty }}</p>
                  </div>
                  <div>
                    上月代充（币）
                    <p>{{ sociaty.yesMonth_sociaty }}</p>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="mg_10">
            <el-card class="box-card" shadow="always">
              <div slot="header" class="clearfix">
                <span style="font-size: 26px;">用户邀请</span>
              </div>
              <el-row style="font-size: 16px;">
                <el-col :span="12">
                  <div>
                    今日有效注册数
                    <p>{{ invite.toDay_invite }}</p>
                  </div>
                  <div>
                    昨日有效注册数
                    <p>{{ invite.yesDay_invite }}</p>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div>
                    本月有效注册数
                    <p>{{ invite.toMonth_invite }}</p>
                  </div>
                  <div>
                    上月有效注册数
                    <p>{{ invite.yesMonth_invite }}</p>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </div>

    <!--调配-->
    <l-dialog :visible.sync="bind_visible" title="绑定" width="800px">
      <admin-bind-user @on-success="onBindSucess" :visible.sync="bind_visible" />
    </l-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2'
import Edit from './Edit.vue'
Vue.use(VueClipboard);
export default {
  name: "home",
  components: {
    [Edit.name]: Edit
  },

  data() {
    return {
      bind_visible: false,
      url: '',
      is_bind: 0,
      loading: false,
      //用户信息
      userInfo: {},
      //个人用户邀请
      invite: {},
      //个人流水  
      recharge: {},
      //公司用户邀请
      inviteDetail: {},
      //公司总流水
      rechargeDetail: {},
      // 个人公会代充 金币
      sociaty: {},
      //公司公会代充 金币
      sociatyDetail: {},
      user_role_name: '',
    };
  },

  mounted() {
    this.getList();
  },
  methods: {
    //点击复制链接
    copy(e) {
      console.log(e.text);
      this.$_msg.success("复制成功");
    },

    getInfoSearch() {
      this.getList();
    },
    getList() {
      this.loading = true;
      this.$_invoke("home_getData", {
      })
        .then((ret) => {
          // console.log(ret);
          this.userInfo = ret.userInfo;
          this.invite = ret.invite;
          this.recharge = ret.recharge;
          this.inviteDetail = ret.inviteDetail;
          this.rechargeDetail = ret.rechargeDetail;
          this.sociaty = ret.sociaty;
          this.sociatyDetail = ret.sociatyDetail;
          this.user_role_name = ret.user_role_name;
          this.is_bind = ret.userInfo.is_bind;
          this.url = ret.qrcode_url;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //编辑成功回调
    onBindSucess() {
      this.bind_visible = false;
      this.getList();
    },
  }
};
</script>
